import angular from 'angular';
import uiRouter from 'angular-ui-router';
import blankComponent from './blank.component';

let blankModule = angular.module('blank', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/');

    $stateProvider
        .state('blank', {
            url: '/blank',
            resolve: {
                currentData: (LoadedModel) => {
                    return LoadedModel.getCurrentSession();
                },
            },
            component: 'blank'
        });
})

.component('blank', blankComponent)

.name;

export default blankModule;



// WEBPACK FOOTER //
// ./client/app/components/blank/blank.js